export function Row({ item, upTrend }) {
    const ppl = item['py'] !== 0 ? Math.floor(((item['pl'] - item['py']) / item['py']).toFixed(4) * 100 * 100) / 100 : 'غیر قابل محاسبه'

    const dateString = item['timestamp'].split('T')[1]
    const Hour = dateString.slice(0, 2)
    const Minute = parseFloat(dateString.slice(3, 5))
    const Second = dateString.slice(7,9)
    const timestamp = `${Hour}:${Minute < 9 ? `0${Minute}` : Minute}:${Second}`

    const url = `http://old.tsetmc.com/Loader.aspx?ParTree=151311&i=${item['tse_url']}`
    const l18Style = item['ind_buy_to_sell_ratio'] > item['lowest_past_cross_value'] ? { color: "#2ea263" } : { color: "#FF0000" }
    const ins_vol_resultant = Math.abs(item['ins_vol_resultant']) > 100 ? "-" : item['ins_vol_resultant'] === 0 ? 0 : item['ins_vol_resultant']
    const resultantABS = item['ins_vol_resultant'] === 0 ? 0 : (item['ins_vol_resultant'] < 0 ? item['ins_vol_resultant'].toString().slice(1) : item['ins_vol_resultant'])
    const baseVol = item['base_vol'] === 0 ? 0 : (item['base_vol'] > 99 ? 99 : item['base_vol'].toFixed(2))

    return (
        <>
            <td className="text-center p-0">
                <div className="fbg-td1 fs-xl-5 p-4 bg-td1 my-4 w-auto border-td-right">
                    {timestamp}
                </div>
            </td>
            <td className=" text-center p-0">
                <div className="bg-td1 fs-xl-5 p-4 bg-td1 mt-4">
                    <a className="l-18" href={url} target="_blank" rel="noreferrer" style={l18Style}>
                        {item['l18']}
                    </a>
                </div>
            </td>
            <td className=" text-center p-0">
                <div
                    className={`bg-td1 fs-xl-5 p-4 bg-td1 mt-4 ${ppl > 0 ? 'text-success' : 'text-danger'}`}
                    dir="ltr">
                    {ppl}
                </div>
            </td>
            <td className=" text-center p-0">
                <div className="bg-td1 fs-xl-5 p-4 bg-td1 mt-4">
                    {item['ind_buy_to_sell_ratio']}
                </div>
            </td>
            <td className="text-center p-0">
                <div className=" bg-td1 fs-xl-5 p-4 mt-4">
                    {item['lowest_past_cross_value']}
                </div>
            </td>
            {upTrend ?
                (
                    <>
                        <td className="text-center p-0">
                            <div className={`bg-td1 fs-xl-5 p-4 mt-4 ${baseVol > 1 ? 'text-success' : 'text-danger'}`} dir="ltr">
                                {baseVol}
                            </div>
                        </td>
                        <td className="text-center p-0">
                            <div className={`bg-td1 fs-xl-5 border-td-left p-4 mt-4 ${ins_vol_resultant > 0 ? 'text-success' : 'text-danger'}`} dir="ltr">
                                {resultantABS}
                            </div>
                        </td>
                    </>
                ) : ''}

        </>
    )
    // }
}